/** A training spot: focused practice under the pines. Qin and xiao over a soft wooden pulse. */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const A_QIN = `@mf 5,. 6,_ 1 2 | 3_ 2_ 1_ 2_ 6,- | 5,_ 6,_ 1_ 2_ 3 5 | 3/- 2- |
  1. 2_ 3 2 | 1_ 6,_ 5,- 6, | 1_ 2_ 3_ 2_ 1 6, | 5,~---`;
const A_XIAO = `0--- | 0--- | 0--- | 0--- | @mp 5. 6_ 1' 6 | 5- 3- | 5_ 6_ 1'_ 6_ 5 3 | 5---`;
const ROOTS_A = `5,, 5,, 1, 5,, 1, 5,, 1, 5,,`;

const B_XIAO = `@mf 1'. 2'_ 1' 6 | 5_ 6_ 5_ 3_ 2- | 3. 5_ 6 1' | 6--- ; | 5. 6_ 5 3 | 2_ 3_ 5_ 6_ 5- | 3_ 2_ 1_ 2_ 3 2 | 5,---`;
const B_QIN = `@mp 1,--- | 5,,--- | 6,,--- | 2,--- | 5,,--- | 2,--- | 6,,--- | 5,,~---`;
const ROOTS_B = `1, 5,, 6,, 2, 5,, 2, 6,, 5,,`;

const PULSE = Array(8).fill(`kp 0 kp 0`).join(' | ');

registerTrack({
  id: 'training',
  order: 15,
  title: 'ฝึกปรือใต้ร่มสน',
  mood: 'สงบ มีสมาธิ แน่วแน่',
  use: 'จุดฝึกฝน (ยืนในจุดฝึก)',
  key: 'D',
  mode: 'zhi',
  bpm: 66,
  meter: 4,
  seed: 1515,
  parts: {
    qin: { inst: 'qin', pan: -0.1, reverb: 0.45 },
    xiao: { inst: 'xiao', gain: 0.85, pan: 0.15, reverb: 0.5 },
    harp: { inst: 'zheng', gain: 0.4, pan: 0.25, reverb: 0.35 },
    pad: { inst: 'pad', gain: 0.5, reverb: 0.5 },
    wood: { inst: 'perc', gain: 0.18, pan: -0.2, reverb: 0.3 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { qin: A_QIN, xiao: A_XIAO, pad: drone(ROOTS_A, 4), wood: PULSE },
    },
    B: {
      bars: 8,
      parts: {
        xiao: B_XIAO,
        qin: B_QIN,
        harp: arp(ROOTS_B, [0, 3, 5, 3, 0, 3, 5, 3]),
        pad: drone(ROOTS_B, 4),
        wood: PULSE,
      },
    },
  },
  form: ['A', 'B', 'A', 'B'],
  loop: true,
});
